import { useRef, useState } from "react";
import Form from "../../form/Form";
import { isEmptyObject } from "./../../../utils/validators/validators";
import { useDispatch, useSelector } from "react-redux";
import {
  addStaffEducationalInfo,
  resetStaffStatus,
} from "./../../../redux/slice/staff/staffSlice";
import useInputChange from "./../../../utils/hooks/useInputChange";
import useFileSelected from "./../../../utils/hooks/useFileSelected";
import { useEffect } from "react";

const AddNewEmployment = ({ creating, setCreating, education_information }) => {
  // const [creating, setCreating] = useState(false)
  const [editing, setEditing] = useState(false);
  const [error, setError] = useState({});

  // initialize input fields
  let initialInputs = {
    institution_name: "",
    start_date: new Date().toISOString().slice(0, 10),
    end_date: new Date().toISOString().slice(0, 10),
    course_of_study: "",
    document: {},
    updating: "updating",
  };

  const [staffInputData, setStaffInputData] = useState(initialInputs);

  const dispatch = useDispatch();
  const certicateRef = useRef();

  // handle input change
  const [input, handleChange] = useInputChange(
    staffInputData,
    setStaffInputData,
    error,
    setError
  );
  const [fileInput, fileChangeHandler] = useFileSelected(
    staffInputData,
    setStaffInputData,
    error,
    setError
  );

  // submit form
  const handleSubmit = () => {
    if (isEmptyObject(error)) {
      dispatch(addStaffEducationalInfo(staffInputData));
    }
  };

  // set current state on component mount
  useEffect(() => {
    if (education_information) {
      setStaffInputData({
        ...staffInputData,
        app_id: education_information[0]?.app_id,
      });
    }
  }, [education_information]);
  return (
    <>
      {creating && (
        <div className='form-wrapper mb-4'>
          <div className='row'>
            <div className='col-md-12'>
              {error.start_date && (
                <div className='alert alert-danger'>{error.start_date}</div>
              )}
            </div>
          </div>
          <Form
            setError={setError}
            submitHandler={handleSubmit}
            values={staffInputData}
          >
            <div className='row g-'>
              <div className='mb-0 col-md-4'>
                <label htmlFor='inputEmail4' className='form-label'>
                  Institution Name
                </label>
                <input
                  textname='Institution name'
                  name='institution_name'
                  onChange={handleChange}
                  value={input.institution_name}
                  type='text'
                  className={`form-control ${
                    error.institution_name && "is-invalid"
                  }`}
                  id='inputEmail4'
                  placeholder='Institution Name'
                />
                {error.institution_name && (
                  <span className='invalid-feedback'>
                    {error.institution_name}
                  </span>
                )}
              </div>
              <div className='col-md-4'>
                <div className='row'>
                  <div className='mb-0 col-md-6'>
                    <label htmlFor='inputEmail5' className='form-label'>
                      Start Date
                    </label>
                    <input
                      type='date'
                      name='start_date'
                      value={input.start_date}
                      onChange={handleChange}
                      className='form-control'
                    />
                  </div>

                  <div className='mb-0 col-md-6'>
                    <label htmlFor='inputEmail5' className='form-label'>
                      End Date
                    </label>
                    <input
                      name='end_date'
                      value={input.end_date}
                      onChange={handleChange}
                      type='date'
                      className='form-control'
                    />
                  </div>
                </div>
              </div>
              <div className='mb-0 col-md-4'>
                <label htmlFor='inputEmail6' className='form-label'>
                  Course of Study
                </label>
                <input
                  textname='Course name'
                  name='course_of_study'
                  onChange={handleChange}
                  value={input.course_of_study}
                  type='text'
                  className={`form-control ${
                    error.course_of_study && "is-invalid"
                  }`}
                  id='inputEmail6'
                  placeholder='Enter Course Name'
                />
                {error.course_of_study && (
                  <span className='invalid-feedback'>
                    {error.course_of_study}
                  </span>
                )}
              </div>
            </div>
            <div className='my-3'>
              <label
                className='btn btn-primary'
                htmlFor='certificate'
                onClick={() => {
                  certicateRef.current.click();
                }}
              >
                Browse Document
              </label>
              {fileInput.document && (
                <a href='#' className='ms-2 text-col'>
                  {fileInput.document.name}
                </a>
              )}
              <input
                type='file'
                className='invisible'
                accept='image/*, application/pdf'
                name='document'
                onChange={fileChangeHandler}
                ref={certicateRef}
              />

              <div className='float-end'>
                <button
                  disabled={editing && true}
                  className='btn btn-warning px-3 text-white'
                  onClick={() => setCreating(false)}
                >
                  Close{" "}
                </button>
                <button
                  disabled={editing && true}
                  className='btn btn-success px-3 ms-2'
                >
                  Save{" "}
                </button>
              </div>
              <div className='clearfix'></div>
            </div>
          </Form>
        </div>
      )}
    </>
  );
};

export default AddNewEmployment;
